module.exports = __webpack_public_path__ + "ajax_loader.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ajax_loader.gif
// module id = 73
// module chunks = 0